import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllPages, clearPageState } from "../redux/slices/pageSlice";
import { Link } from "react-router-dom";

const PagesList = () => {
    const dispatch = useDispatch();
    const { pages, total, loading, error } = useSelector((state) => state.page);

    // Local state for pagination and search
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const limit = 10; // fixed items per page

    // Fetch pages whenever page or search changes
    useEffect(() => {
        dispatch(fetchAllPages({ page, limit, search }));
        return () => dispatch(clearPageState());
    }, [dispatch, page, search]);


    const totalPages = Math.ceil(total / limit);

    return (
        <div className="container mt-5">
            <div className="card">
                <div className="card-header d-flex justify-content-between">
                    <h4 className="mb-0">Pages List</h4>

                    <Link to="/page-editor" className="btn btn-sm btn-primary">
                        Add New Page Content
                    </Link>

                </div>
                <div className="card-body">
                    {/* Search input */}
                    <div className="mb-5">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search pages..."
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(1); // reset to first page on search
                            }}
                        />
                    </div>

                    {loading && <p>Loading...</p>}
                    {error && <p className="text-danger">{error}</p>}

                    {/* Table */}
                    <table className="table table-bordered table-hover">
                        <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th>Page Title</th>
                                <th>Slug</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pages.length > 0 ? (
                                pages.map((p, idx) => (
                                    <tr key={p.slug}>
                                        <td>{(page - 1) * limit + idx + 1}</td>
                                        <td>{p.pageTitle}</td>
                                        <td>{p.slug}</td>
                                        <td>
                                            <Link
                                                to={`/edit-page/${p.slug}`}
                                                className="btn btn-primary btn-sm me-2"
                                            >
                                                Edit
                                            </Link>
                      
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        No pages found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                </div>
            </div>




            {/* Pagination */}
            {totalPages > 1 && (
                <nav>
                    <ul className="pagination justify-content-center">
                        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                            <button
                                className="page-link"
                                onClick={() => setPage((prev) => prev - 1)}
                            >
                                Previous
                            </button>
                        </li>

                        {[...Array(totalPages)].map((_, idx) => (
                            <li key={idx + 1} className={`page-item ${page === idx + 1 ? "active" : ""}`}>
                                <button className="page-link" onClick={() => setPage(idx + 1)}>
                                    {idx + 1}
                                </button>
                            </li>
                        ))}

                        <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => setPage((prev) => prev + 1)}>
                                Next
                            </button>
                        </li>
                    </ul>
                </nav>
            )}
        </div>
    );
};

export default PagesList;
